import React from "react";
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { ethers } from "ethers";

// ---- CONFIG ----
const DOS_CONTRACT_ADDRESS = "0xDEBc06Cb843d36714a13C1Cb6cde49C168F5C7fb"; // mainnet DOS
// ----------------

const DEFAULT_TOKEN_ID = 0; // used when no id is in the url (cypherdudes.com/dos)

const DOS_ABI = [
    "function tokenHTML(uint256 tokenId) view returns (string)"
];

const Dos = () => {
    const params = useParams();
    const parsed = parseInt(params.tokenId);
    const id = isNaN(parsed) ? DEFAULT_TOKEN_ID : parsed;

    const [html, setHtml] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTokenHTML = async () => {
            try {
                // Shared resilient provider: Infura first, public RPC fallback
                const { infuraProvider } = require("../web3/providers");
                const dosReadContract = new ethers.Contract(
                    DOS_CONTRACT_ADDRESS,
                    DOS_ABI,
                    infuraProvider
                );
                const tokenHTML = await dosReadContract.tokenHTML(id);
                if (!tokenHTML) {
                    setError("EMPTY RESPONSE FROM CONTRACT");
                    return;
                }
                setHtml(tokenHTML);
            } catch (err) {
                console.log(err);
                setError("ERROR: " + (err.reason || err.message));
            }
        };
        fetchTokenHTML();
    }, [id]);

    // Wallet extensions don't inject window.ethereum into srcdoc iframes.
    // The frame is same-origin (sandbox allow-same-origin), so we hand the
    // parent's EIP-1193 provider through — every eth call in the world
    // (COS_ethCalls.js) goes through window.ethereum.request(), so forwarding
    // the provider object covers them all, events included.
    const forwardWallet = (iframe) => {
        try {
            if (window.ethereum && iframe.contentWindow) {
                iframe.contentWindow.ethereum = window.ethereum;
            }
        } catch (e) {
            console.log('forwardWallet failed:', e);
        }
    };

    // The app-wide `body { background-color: #000 }` (index.css) alters the
    // webgl rendering — clear it on this route only, restore on leave.
    useEffect(() => {
        const previous = document.body.style.backgroundColor;
        document.body.style.backgroundColor = 'transparent';
        return () => { document.body.style.backgroundColor = previous; };
    }, []);

    // auto-hide nav, same behavior as cypherpalace
    useEffect(() => {
        const onMouseMove = (event) => {
            const nav = document.getElementById("navMenu");
            if (!nav) return;
            if (event.clientY < 50) {
                nav.style.transform = "translateY(0)";
            } else {
                nav.style.transform = "translateY(-100%)";
            }
            nav.style.transition = "transform 0.3s ease-in-out";
        };
        document.addEventListener("mousemove", onMouseMove);
        return () => document.removeEventListener("mousemove", onMouseMove);
    }, []);

    return (
        <div className="palaceContainer">
            <div className='palacePreview'>
                {error ? <h2 style={{ color: '#00ff00', textAlign: 'center', marginTop: '40vh' }}>{error}</h2> :
                    html && <iframe id="dosFrame" title={`DOS #${id}`} sandbox="allow-scripts allow-same-origin allow-pointer-lock" frameBorder="0" srcDoc={html} onLoad={(e) => forwardWallet(e.target)}></iframe>}
            </div>
        </div>
    );
};

export default Dos;
